import { css } from '@emotion/react';
import { useHelper } from 'src/hooks';
import { useMemo } from 'react';
import Spinner from './Spinner';
import styled from '@emotion/styled';

interface Props {
  title?: string;
  price?: number | string;
  currency?: string;
  isTotal?: boolean;
}

function PaymentRow(props: Props): JSX.Element {
  /* Define state / hook */
  const { title, price, currency, isTotal = false } = props;
  const { displayCurrency } = useHelper();

  /* Custom Data Object for render or other usages */

  /* Render control function / logic */

  /* Data Change Listeners - useEffect/useMemo/useCallback */

  /* Styling */
  const Row = useMemo(
    () => styled.div`
      display: flex;
      justify-content: space-between;
      align-items: center;
      p {
        font-size: 1.5em;
        color: var(--primary-color9);
      }

      ${isTotal &&
      css`
        p {
          margin: 0.5em 0em;
          color: var(--primary-color2);
          font-size: 1.8em;
          font-weight: bold;
        }
      `};
    `,
    [isTotal]
  );

  /* Render */
  return title ? (
    <Row>
      <p>{title}</p>
      <p>
        {Number.isNaN(Number(price)) || currency == null ? (
          <Spinner />
        ) : (
          displayCurrency(price, currency)
        )}
      </p>
    </Row>
  ) : (
    <div />
  );
}

export default PaymentRow;
